import { HttpParams } from '@angular/common/http';
import { PaginationOptions } from '../store/types';

export const createPaginationQueryParams = (
  paginationOptions: PaginationOptions,
): HttpParams => {
  let queryParams = new HttpParams();
  if (paginationOptions.take) {
    queryParams = queryParams.set('take', paginationOptions.take);
  }
  if (paginationOptions.skip) {
    queryParams = queryParams.set('skip', paginationOptions.skip);
  }
  if (paginationOptions.sort) {
    queryParams = queryParams.set(
      'sort',
      JSON.stringify(paginationOptions.sort),
    );
  }
  if (paginationOptions.search) {
    queryParams = queryParams.set(
      'search',
      JSON.stringify(paginationOptions.search),
    );
  }

  return queryParams;
};
